function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "checked (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10712"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46647",
    d: "M10 0a10 10 0 1 0 10 10A10.012 10.012 0 0 0 10 0zm5.589 7.368L9.2 13.709a.983.983 0 0 1-1.378.025l-3.386-3.082a1.016 1.016 0 0 1-.075-1.4.992.992 0 0 1 1.4-.05l2.682 2.456L14.16 5.94a1.01 1.01 0 1 1 1.429 1.429z",
    style: {
      fill: "#0ea03f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked-1.418d47c035a395645e9aaeffe757b6ae.svg";
export { ForwardRef as ReactComponent };